import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import * as firebase from "firebase"
import store from "./store";
import router from './router'
import VueExpandableImage from 'vue-expandable-image'
import ProductZoomer from 'vue-product-zoomer'
import money from 'v-money'


Vue.config.productionTip = false

const configOptions = {
  apiKey: "AIzaSyCT5QOl_EVct8gO_CKskAQzx8bSSxqrRkU",
  authDomain: "quoon-br.firebaseapp.com",
  databaseURL: "https://quoon-br.firebaseio.com",
  projectId: "quoon-br",
  storageBucket: "quoon-br.appspot.com",
  messagingSenderId: "309160836285",
  appId: "1:309160836285:web:b93d73233b9fd235d24bd4",
  measurementId: "G-WXCS0P9ZFV",
};

firebase.initializeApp(configOptions);

Vue.use(VueExpandableImage);
Vue.use(ProductZoomer);
Vue.use(money, {precision: 4})


new Vue({
  router,
  store,
  vuetify,  
  render: h => h(App)
}).$mount('#app')

export const db = firebase.firestore()
export const files = firebase.storage()
